import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}

export function formatRelativeTime(input: string | Date | null | undefined): string {
    if (!input) return "—";
    const date = typeof input === "string" ? new Date(input) : input;
    const diffMs = Date.now() - date.getTime();
    const diffSec = Math.round(diffMs / 1000);
    if (Math.abs(diffSec) < 60) return `${Math.abs(diffSec)}s ago`;
    const diffMin = Math.round(diffSec / 60);
    if (Math.abs(diffMin) < 60) return `${Math.abs(diffMin)}m ago`;
    const diffHour = Math.round(diffMin / 60);
    if (Math.abs(diffHour) < 24) return `${Math.abs(diffHour)}h ago`;
    const diffDay = Math.round(diffHour / 24);
    if (Math.abs(diffDay) < 30) return `${Math.abs(diffDay)}d ago`;
    return date.toISOString().slice(0, 10);
}

export function formatDate(input: string | Date | null | undefined, options?: Intl.DateTimeFormatOptions): string {
    if (!input) return "—";
    const date = typeof input === "string" ? new Date(input) : input;
    return date.toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
        ...options,
    });
}
